import { render } from "./KeyHighlight.vue?vue&type=template&id=1e23ad58"
import script from "./KeyHighlight.vue?vue&type=script&lang=js"
export * from "./KeyHighlight.vue?vue&type=script&lang=js"

import "./KeyHighlight.vue?vue&type=style&index=0&id=1e23ad58&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__